/**
 * Pronouns options for client profiles.
 * TODO: Replace with API call when endpoint becomes available.
 */
const PRONOUNS = [
  'she',
  'her',
  'he',
  'him',
  'they',
  'them',
  'ae',
  'co',
  'cos',
  'e',
  'eir',
  'em',
  'ey',
  'fae',
  'faer',
  'fey',
  'hers',
  'hir',
  'his',
  'hu',
  'jee',
  'kit',
  'mer',
  'mers',
  'ne',
  'nee',
  'ner',
  'ners',
  'nir',
  'nirs',
  'peh',
  'per',
  'pers',
  'se',
  'shi',
  'si',
  'sie',
  'theirs',
  'thon',
  'thons',
  've',
  'ver',
  'ves',
  'vi',
  'vim',
  'vir',
  'vis',
  'xem',
  'xe',
  'xeir',
  'xey',
  'xie',
  'xyr',
  'yo',
  'ze',
  'zee',
  'zem',
  'zie',
  'zir',
  'zme',
];

export default PRONOUNS;
